import {
  PERFORM_LOGIN_START,
  PERFORM_LOGIN_COMPLETE,
  PERFORM_LOGIN_ERROR,
  VERIFY_RESET_PASSWORD_EMAIL_START,
  VERIFY_RESET_PASSWORD_EMAIL_COMPLETE,
  VERIFY_RESET_PASSWORD_EMAIL_ERROR,
  VERIFY_RESET_PASSWORD_OTP_START,
  VERIFY_RESET_PASSWORD_OTP_COMPLETE,
  VERIFY_RESET_PASSWORD_OTP_ERROR,
  VERIFY_EMAIL_OTP_START,
  VERIFY_EMAIL_OTP_COMPLETE,
  VERIFY_EMAIL_OTP_ERROR,
  CLEAR_LOGIN_ERROR,
  CLEAR_FORGOT_PASSWORD_ERROR,
  LOGOUT,
} from './actions';

let initialState = {
  loginStarted: false,
  loginError: undefined,
  verifyEmailOtpError: undefined,
  isVerifyEmailOtpStarted: false,
  verifyResetPasswordEmailError: undefined,
  isVerifyResetPasswordOtpStarted: false,
  verifyResetPasswordOtpError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case PERFORM_LOGIN_START:
      return {
        ...state,
        loginStarted: true,
        isVerifyEmailOtpStarted: false,
        loginError: undefined,
        loginToken: undefined,
      };
    case PERFORM_LOGIN_COMPLETE:
      return {
        ...state,
        loginStarted: false,
        loginError: undefined,
        loginToken: payload.data,
      };
    case PERFORM_LOGIN_ERROR:
      return {
        ...state,
        loginError: payload.error,
        loginStarted: false,
        loginToken: undefined,
      };
    case VERIFY_RESET_PASSWORD_EMAIL_START:
      return {
        ...state,
        isVerifyResetPasswordEmailStarted: true,
        verifyResetPasswordEmailError: undefined,
        phoneNumberToken: undefined,
      };
    case VERIFY_RESET_PASSWORD_EMAIL_COMPLETE:
      return {
        ...state,
        isVerifyResetPasswordEmailStarted: false,
        verifyResetPasswordEmailError: undefined,
        phoneNumberToken: payload.data,
      };
    case VERIFY_RESET_PASSWORD_EMAIL_ERROR:
      return {
        ...state,
        verifyResetPasswordEmailError: payload.error,
        isVerifyResetPasswordEmailStarted: false,
        phoneNumberToken: undefined,
      };
    case VERIFY_RESET_PASSWORD_OTP_START:
      return {
        ...state,
        isVerifyResetPasswordOtpStarted: true,
        verifyResetPasswordOtpError: undefined,
        otpToken: undefined,
      };
    case VERIFY_RESET_PASSWORD_OTP_COMPLETE:
      return {
        ...state,
        isVerifyResetPasswordOtpStarted: false,
        verifyResetPasswordOtpError: undefined,
        otpToken: payload.data,
      };
    case VERIFY_RESET_PASSWORD_OTP_ERROR:
      return {
        ...state,
        verifyResetPasswordOtpError: payload.error,
        isVerifyResetPasswordOtpStarted: false,
        otpToken: undefined,
      };
    case VERIFY_EMAIL_OTP_START:
      return {
        ...state,
        isVerifyEmailOtpStarted: true,
        verifyEmailOtpError: undefined,
      };
    case VERIFY_EMAIL_OTP_COMPLETE:
      return {
        ...state,
        isVerifyEmailOtpStarted: false,
        verifyEmailOtpError: undefined,
      };
    case VERIFY_EMAIL_OTP_ERROR:
      return {
        ...state,
        verifyEmailOtpError: payload.error,
        isVerifyEmailOtpStarted: false,
      };
    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        verifyEmailOtpError: undefined,
        loginError: undefined,
      };
    case CLEAR_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        verifyResetPasswordOtpError: undefined,
        verifyResetPasswordEmailError: undefined,
      };
    case LOGOUT: 
      return initialState;
    default:
      return state;
  }
};

export default reducer;
